import styled, { css } from "styled-components";

type FlexAlignItemsProp = "flex-start" | "flex-end" | "stretch" | "center" | "baseline";
type FlexJustifyContentProp = "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly";

/* styled components css interpolations */

export const flexRowContainerMixin = css`
    display: flex;
    flex-direction: row;
`;
export const flexRowReverseContainerMixin = css`
    display: flex;
    flex-direction: row-reverse;
`;
export const flexColumnContainerMixin = css`
    display: flex;
    flex-direction: column;
`;

export const flexAlignItemsMixin = (props: {alignItems?: FlexAlignItemsProp;}) => css`
    align-items: ${props.alignItems || "unset"};
`;
export const flexJustifyContentMixin = (props: {justifyContent?: FlexJustifyContentProp;}) => css`
    justify-content: ${props.justifyContent || "unset"};
`;
export const flexCenterAlignItemsMixin = css`
    ${flexAlignItemsMixin({alignItems: "center"})}
`;

export const flexGrowItem = (props: {flexBasis?: string;}) => css`
    flex: 1 0 ${props.flexBasis || "auto"};
`;
export const flexFixedSizeItem = css`
    flex: 0 0 auto;
`;
export const flexAdaptiveSizeItem = css`
    flex: 1 1 auto;
`;

/* styled based components, to be used as is or as Base to be extended */

export const FlexGrowItemBox = styled.div`
    ${flexGrowItem}
`;

export const FlexContainerBox = styled.div<{
    alignItems?: FlexAlignItemsProp;
    justifyContent?: FlexJustifyContentProp;
}>`
    ${flexRowContainerMixin}
    ${flexAlignItemsMixin}
    ${flexJustifyContentMixin}
`;
